import getParsedOmeMessageStatus from './getParsedOmeMessageStatus';
import type OmeMessageState from '../store/schema/OmeMessageState';
import type ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import getExtendedPropertyValue from 'owa-mail-store/lib/utils/getExtendedPropertyValue';
import type Message from 'owa-service/lib/contract/Message';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

const OME_MESSAGE_STATE_PROPERTY_NAME = 'x-ms-exchange-organization-ome-messagestate';
export const sentItemsFolder: string = 'sentitems';

export default function getInitialOmeMessageState(message: Message | ClientItem): OmeMessageState {
    if (
        message?.ParentFolderId?.Id &&
        folderIdToName(message.ParentFolderId.Id) !== sentItemsFolder
    ) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (16,9): Type 'null' is not assignable to type 'OmeMessageState'.
        // @ts-expect-error
        return null;
    }

    const omeMessageStateValue = getExtendedPropertyValue(
        message,
        null /*Tag*/,
        OME_MESSAGE_STATE_PROPERTY_NAME
    );

    return getParsedOmeMessageStatus(omeMessageStateValue);
}
